export default __webpack_public_path__ + "fill-color.asset.b66080e534b429025c24e91e87269139.svg";